/**
 * 消息提示封装
 * @param {Object} res
 */
let alert = function(res) {
	let msg = '';
	let duration = 2000
	if (typeof res == 'object') {
		msg = res.msg || res.message;
		if (res.code != 200) { //错误提示时延长提示时间
			duration = 2500
		}
	} else {
		msg = res
	}
	uni.showToast({
		title: msg,
		icon: 'none',
		duration: duration || 2000
	})
}

export default {
	alert,
};